import { atom } from 'jotai';

export const clientFilterChipAtom = atom<{
  sellerNameList: string[];
  domainType: string;
}>({
  sellerNameList: [],
  domainType: '',
});
